import React, { useEffect, useState } from 'react';
import { Button, Grid, Header } from 'semantic-ui-react';
import { PhotoWidgetDropzone } from './PhotoWidgetDropzone';
import { DropzoneFile } from '../../models/dropzone';
import { PhotoWidgetCropper } from './PhotoWidgetCropper';

interface Props {
  uploadPhoto: (file: Blob) => Promise<void>;
  loading: boolean;
}

const PhotoUploadWidget: React.FC<Props> = ({ uploadPhoto, loading }) => {
  const [files, setFiles] = useState<DropzoneFile[]>([]);
  const [cropper, setCropper] = useState<Cropper>();

  const onCrop = () => {
    if (cropper) {
      cropper.getCroppedCanvas().toBlob((blob) => {
        if (blob === null) return;
        uploadPhoto(blob);
      });
    }
  };

  useEffect(
    function componentCleanups() {
      const cleanup = () => {
        files.forEach((file) => URL.revokeObjectURL(file.preview));
      };
      return cleanup;
    },
    [files],
  );

  return (
    <Grid>
      <Grid.Column width={4}>
        <Header sub color="teal" content="Step 1 - Add Photo" />
        <PhotoWidgetDropzone
          setFiles={(files: DropzoneFile[]) => setFiles(files)}
        />
      </Grid.Column>
      <Grid.Column width={1} />
      <Grid.Column width={4}>
        <Header sub color="teal" content="Step 2 - Resize image" />
        {files.length > 0 && (
          <PhotoWidgetCropper
            imagePreview={files[0].preview}
            setCropper={setCropper}
          />
        )}
      </Grid.Column>
      <Grid.Column width={1} />
      <Grid.Column width={4}>
        <Header sub color="teal" content="Step 3 - Preview & Upload" />
        {files.length > 0 && (
          <>
            <div
              className="img-preview"
              style={{ minHeight: 200, overflow: 'hidden' }}
            />
            <Button.Group widths={2}>
              <Button
                onClick={onCrop}
                positive
                icon="check"
                loading={loading}
              />
              <Button
                onClick={() => setFiles([])}
                icon="close"
                disabled={loading}
              />
            </Button.Group>
          </>
        )}
      </Grid.Column>
    </Grid>
  );
};

export { PhotoUploadWidget };
